interface IApiError {
  message: string | undefined;
  statusCode: number | string;
  errorCode: number | string;
  errorMessage: string;
  errorMetadata?: unknown;
  configRequest?: unknown;
  serviceResponse?: Record<string, unknown>;
}
class ApiError extends Error {
  statusCode: number | string;
  errorCode: number | string;
  errorMessage: string;
  errorMetadata?: unknown;
  configRequest?: unknown;
  serviceResponse?: Record<string, unknown>;
  constructor({
    message,
    statusCode,
    errorCode,
    errorMessage,
    errorMetadata,
    configRequest,
    serviceResponse,
  }: IApiError) {
    super(message);
    this.name = 'ApiException';
    this.statusCode = statusCode;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    this.errorMetadata = errorMetadata;
    this.configRequest = configRequest;
    this.serviceResponse = serviceResponse;
  }
}

export default ApiError;
